/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Group_EarlierInputs */

const en_notifications_group_earlier = /** @type {(inputs: Notifications_Group_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Older`)
};

const pl_notifications_group_earlier = /** @type {(inputs: Notifications_Group_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starsze`)
};

/**
* | output |
* | --- |
* | "Older" |
*
* @param {Notifications_Group_EarlierInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_group_earlier = /** @type {((inputs?: Notifications_Group_EarlierInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Group_EarlierInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_group_earlier(inputs)
	return en_notifications_group_earlier(inputs)
});